<div class="container">
  <div class="row">
    <header class="header-top">
      <nav class="navbar navbar-light">
        <div class="navbar-left">
          <div class="logo-area">
            <a
              class="navbar-brand"
              href="javascript:void(0)"
              (click)="onLogoClick()"
            >
              <img class="dark" src="assets/img/logo.svg" alt="logo" />
              <img class="light" src="assets/img/logo.svg" alt="logo" />
            </a>
          </div>
        </div>
        <div
          class="navbar-right d-flex justify-content-center align-items-center"
        >
          <button
            class="lang-globe-btn"
            (click)="openLangModal()"
            [attr.aria-label]="'Change language'"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path
                d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
              />
            </svg>
            <span class="lang-globe-label">{{
              lang.currentLang.toUpperCase()
            }}</span>
          </button>
          <ul class="navbar-right__menu">
            <!-- <li class="nav-language">
              <div class="dropdown-custom">
                <a href="javascript:void(0)" class="nav-language__current">
                  <span>{{ "language." + lang.currentLang | translate }}</span>
                  <i class="las la-angle-down"></i>
                </a>
                <div class="dropdown-parent-wrapper">
                  <div class="dropdown-wrapper">
                    <div class="nav-language__options">
                      <a
                        href="javascript:void(0)"
                        *ngFor="let lng of ['en', 'de', 'ja', 'es', 'fr']"
                        (click)="lang.setLang(lng)"
                        [class.active]="lang.currentLang === lng"
                      >
                        {{ "language." + lng | translate }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </li> -->

            <li class="nav-author">
              <div class="dropdown-custom">
                <a href="javascript:void(0)" class="">
                  <span class="nav-item__title"
                    >{{ customer_email
                    }}<i class="las la-angle-down nav-item__arrow"></i
                  ></span>
                </a>
                <div class="dropdown-parent-wrapper">
                  <div class="dropdown-wrapper">
                    <a
                      href="/dashboard?email={{ email }}"
                      *ngFor="let email of customer_form_emails"
                      class="nav-author__info"
                      style="cursor: pointer"
                    >
                      <div>
                        <span>{{ email }}</span>
                      </div>
                    </a>
                    <!-- <div class="nav-author__info">
                      <div>
                        <span>email_2@gmail.com</span>
                      </div>
                    </div> -->
                    <div class="nav-author__options">
                      <ul>
                        <li
                          *ngIf="isFullAccess && !isSubcustomer && !isInactive"
                        >
                          <a href="/emails/monitoring">
                            <i class="uil uil-envelope"></i>
                            <!-- Additional emails monitoring -->
                            {{ "header.additionalEmails" | translate }}
                          </a>
                        </li>
                        <li *ngIf="isFullAccess && !isInactive">
                          <a href="/profile">
                            <i class="uil uil-user"></i>
                            <!-- Profiles -->
                            {{ "header.profiles" | translate }}
                          </a>
                        </li>
                        <li *ngIf="!isSubcustomer && !isInactive">
                          <a href="/subscriptions">
                            <i class="uil uil-key-skeleton"></i>
                            <!-- Subscriptions -->
                            {{ "header.subscriptions" | translate }}
                          </a>
                        </li>
                      </ul>
                      <a
                        href=""
                        class="nav-author__signout"
                        (click)="logout($event)"
                      >
                        <i class="uil uil-sign-out-alt"></i>
                        <!-- Sign Out -->
                        {{ "header.signOut" | translate }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div
            class="navbar-right__mobileAction navbar-toggler d-md-none"
            data-bs-toggle="collapse"
            data-bs-target="#mobileAuthorActions"
            aria-controls="mobileAuthorActions"
          >
            <a href="javascript:void(0)" class="btn-author-action">
              <img
                class="svg"
                src="assets/img/svg/more-vertical.svg"
                alt="more-vertical"
            /></a>
          </div>
        </div>
      </nav>
    </header>

    <div class="collapse mobile-author-actions" id="mobileAuthorActions">
      <ul class="navbar-nav" style="width: 100%">
        <li class="nav-item">
          <a class="nav-link" href="/profile">
            <i class="uil uil-user"></i>
            <!-- Profiles -->
            {{ "header.profiles" | translate }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/subscriptions">
            <i class="uil uil-key-skeleton"></i>
            <!-- Subscriptions -->
            {{ "header.subscriptions" | translate }}
          </a>
        </li>
        <li class="nav-item" style="background-color: #f4f5f7">
          <a
            class="nav-link"
            href=""
            (click)="logout($event)"
            style="justify-content: center"
          >
            <i class="uil uil-sign-out-alt"></i>
            <!-- Sign Out -->
            {{ "header.signOut" | translate }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>

<div>
  <br />
</div>
<div
  class="lang-modal-overlay"
  [class.active]="isLangModalOpen"
  (click)="closeLangModal()"
>
  <div class="lang-modal" (click)="$event.stopPropagation()">
    <div class="lang-modal__header">
      <span class="lang-modal__title">{{ "choose_language" | translate }}</span>
      <button class="lang-modal__close" (click)="closeLangModal()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div class="lang-modal__list">
      <button
        *ngFor="let l of langOptions"
        class="lang-modal__item"
        [class.lang-modal__item--active]="lang.currentLang === l.code"
        (click)="selectLang(l.code)"
      >
        <span class="lang-modal__flag">{{ l.flag }}</span>
        <span class="lang-modal__name">{{ l.name }}</span>
        <span class="lang-modal__code">{{ l.code.toUpperCase() }}</span>
        <svg
          *ngIf="lang.currentLang === l.code"
          class="lang-modal__check"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </button>
    </div>
  </div>
</div>
